import React from "react";
import { connect } from "react-redux";
import { FormattedMessage, injectIntl } from "react-intl";
import ComboBox from "../../../sub/ComboBox";
import { addCollaboratorType } from "../../../../actions/configurables/collaboratorTypes";
import Util from "../../../../util/Util";
import {
  addCollaborator,
  updateCollaborator,
} from "../../../../actions/collaborators/collaborators";
import {
  checkIfUsernameExists,
  checkIfEmailExists,
  checkIfEmailIsValid,
  sendWelcomeEmail,
} from "../../../../actions/user/user";
import CustomLabel from "../../../sub/CustomLabel";
import InputLength from "../../../../enums/InputLength";
import InputTextElement from "../../../sub/InputTextElement";
import { Alert, Col, Form, Row } from "react-bootstrap";
import MenuButton from "../../../sub/bootstrap/MenuButton";
import Fieldset from "../../../sub/Fieldset";
import Legend from "../../../sub/Legend";
import SwitchToggle from "../../../sub/SwitchToggle";
import Icon from "../../../sub/Icon";
import ConfirmationModal from "../../../sub/modals/ConfirmationModal";

class Collaborator extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      username: "",
      name: "",
      first_name: "",
      email: "",
      collaborator_type_id: "",
      phone: "",
      notifyByEmail: true,

      usernameError: null,
      emailError: null,
      disabled: false,
      modal: null,
    };

    if (this.isUpdate()) {
      this.state = {
        username: this.props.collaborator.username,
        name: this.props.collaborator.name,
        first_name: this.props.collaborator.first_name,
        email: this.props.collaborator.email,
        collaborator_type_id:
          this.props.collaborator.collaborator_type_id || "",
        phone: this.props.collaborator.phone || "",
        phoneError: null,
        usernameError: null,
        emailError: null,
        disabled: false,
        modal: null,
      };
    }
  }

  isUpdate() {
    return (
      this.props.collaborator !== undefined && this.props.collaborator !== null
    );
  }

  close() {
    this.props.close();
  }

  closeModal() {
    this.setState({ modal: null });
  }

  stopEvent(e) {
    e.stopPropagation();
  }

  onChange(field, value) {
    this.setState({ [field]: value });

    if (field === "phone") {
      if (!Util.emptyString(value) && !Util.isPhone(value))
        this.setState({
          phoneError: <FormattedMessage id="Invalid.Phone.Number.Error" />,
        });
      else this.setState({ phoneError: null });
    } else if (field === "email") {
      if (Util.emptyString(value)) return;

      if (this.isUpdate() && this.props.collaborator.email === value) {
        this.setState({ emailError: null });
        return;
      }

      if (!Util.isEmail(value)) {
        this.setState({ emailError: <FormattedMessage id="Invalid.Email" /> });
        return;
      } else {
        this.props.onCheckIfEmailIsValid(
          value,
          (response) => {
            this.setState({ emailError: null });
          },
          (response) => {
            this.setState({
              emailError: (
                <span>
                  <FormattedMessage id="Invalid.Email.Error" /> (
                  {response.data.reason})
                </span>
              ),
            });
            return;
          },
        );
      }
    } else if (field === "notifyByEmail") {
      this.setState({ notifyByEmail: value });
    }

    if (field === "username") {
      if (Util.emptyString(value)) return;

      // Force this value to be in lowercase
      value = value.toLowerCase();

      this.setState({ [field]: value });

      // Test username syntax
      var checkUsername = Util.isValidUserName(value, 3, 20);
      if (checkUsername instanceof Object === true) {
        this.setState({
          usernameError: (
            <FormattedMessage
              id="Invalid.Username"
              values={{
                minLength: checkUsername.minLength,
                maxLength: checkUsername.maxLength,
              }}
            />
          ),
        });
        return;
      } else {
        this.setState({ usernameError: null });
      }

      if (this.isUpdate() && this.props.collaborator.username === value) {
        this.setState({ usernameError: null });
        return;
      }

      this.props.onCheckIfUsernameExists(
        value,
        () => {
          this.setState({
            usernameError: (
              <FormattedMessage
                id="Username.Already.Exists"
                values={{ username: value }}
              />
            ),
          });
        },
        () => {
          this.setState({ usernameError: null });
        },
      );
    }
  }

  update(field) {
    if (this.disabled() || !this.isUpdate()) return;

    if (
      this.isUpdate() &&
      field === "email" &&
      this.props.collaborator.email === this.state[field]
    )
      return;

    if (
      this.isUpdate() &&
      field === "username" &&
      this.props.collaborator.username === this.state[field]
    )
      return;

    this.props.onUpdateCollaborator({
      collaboratorId: this.props.collaborator._id,
      updatedField: field,
      updatedValue: this.state[field],
    });
  }

  disabled() {
    return (
      Util.emptyString(this.state.username) ||
      Util.emptyString(this.state.name) ||
      Util.emptyString(this.state.first_name) ||
      Util.emptyString(this.state.email) ||
      !Util.isEmail(this.state.email) ||
      this.state.emailError ||
      this.state.phoneError ||
      this.state.usernameError ||
      this.state.disabled
    );
  }

  onSubmit() {
    if (this.disabled()) return;

    // Prepare data to send to the BE, exclude irrelevant fields
    var { disabled, ...data } = this.state;

    // Remove empty values
    Object.keys(data).forEach(
      (key) => Util.emptyString(data[key]) && delete data[key],
    );

    // Lock the button
    this.setState({ disabled: true });

    // Send to BE
    this.props.onAddCollaborator(data, (collaborator) =>
      this.props.onCollaboratorCreated(collaborator),
    );
  }

  openEmailSent() {
    this.setState({
      modal: (
        <ConfirmationModal
          variant={"success"}
          title={<FormattedMessage id="Mail.Account.Created" />}
          cancelButtonDisabled
          confirmButtonLabel={this.props.intl.formatMessage({
            id: "Close",
          })}
          onAccept={() => {
            this.closeModal();
          }}
        >
          <FormattedMessage id="Mail.Sent.Success" />
        </ConfirmationModal>
      ),
    });
  }

  render() {
    return (
      <React.Fragment>
        {!this.isUpdate() && (
          <Alert variant="info">
            <FormattedMessage id="Collaborator.Account.Creation.Info" />
          </Alert>
        )}
        <Fieldset>
          <Legend>
            <FormattedMessage id="Identity" />
          </Legend>
          <Form.Group as={Row} className="mb-3 align-items-center">
            <CustomLabel
              label={this.props.intl.formatMessage({ id: "Name" })}
              htmlFor="name"
              displayAsCol
              required
            />
            <Col md={7}>
              <InputTextElement
                type="text"
                id="name"
                autoComplete="off"
                maxLength={InputLength.NAME}
                value={this.state.name}
                onChange={(e) =>
                  this.onChange("name", e.target.value.toUpperCase())
                }
                onBlur={(e) => this.update("name", e.target.value)}
              />
            </Col>
          </Form.Group>
          <Form.Group as={Row} className="mb-3 align-items-center">
            <CustomLabel
              label={this.props.intl.formatMessage({ id: "First.Name" })}
              htmlFor="first_name"
              displayAsCol
              required
            />
            <Col md={7}>
              <InputTextElement
                className="text-capitalize"
                type="text"
                id="first_name"
                autoComplete="off"
                maxLength={InputLength.NAME}
                value={this.state.first_name}
                onChange={(e) =>
                  this.onChange("first_name", e.target.value.toLowerCase())
                }
                onBlur={(e) => this.update("first_name", e.target.value)}
              />
            </Col>
          </Form.Group>
          <Form.Group as={Row} className="mb-3 align-items-center">
            <CustomLabel
              label={this.props.intl.formatMessage({ id: "Function" })}
              htmlFor="collaborator_type_id"
              displayAsCol
            />
            <Col md={7}>
              <ComboBox
                menuPlacement="auto"
                onChange={(value) =>
                  this.onChange("collaborator_type_id", value)
                }
                onBlur={(value) => this.update("collaborator_type_id", value)}
                defaultOption={this.state.collaborator_type_id}
                options={this.props.collaboratorTypes}
                onCreateOption={(data, successCallback) =>
                  this.props.onAddCollaboratorType(data, successCallback)
                }
              />
            </Col>
          </Form.Group>
        </Fieldset>

        <Fieldset>
          <Legend>
            <FormattedMessage id="Contact.Information" />
          </Legend>
          <Form.Group as={Row} className="mb-3 align-items-center">
            <CustomLabel
              label={this.props.intl.formatMessage({ id: "Email" })}
              htmlFor="email"
              displayAsCol
              required
            />
            <Col md={7}>
              <InputTextElement
                type="text"
                id="email"
                autoComplete="off"
                maxLength={InputLength.EMAIL}
                value={this.state.email}
                onChange={(e) => this.onChange("email", e.target.value)}
                onBlur={(e) => this.update("email", e.target.value)}
              />
              <div className="text-danger">
                <small>{this.state.emailError}</small>
              </div>
            </Col>
          </Form.Group>
          <Form.Group as={Row} className="mb-3 align-items-center">
            <CustomLabel
              label={this.props.intl.formatMessage({ id: "Phone" })}
              htmlFor="phone"
              displayAsCol
            />
            <Col md={7}>
              <InputTextElement
                type="number"
                id="phone"
                autoComplete="off"
                maxLength={InputLength.PHONE}
                value={this.state.phone}
                onChange={(e) => this.onChange("phone", e.target.value)}
                onBlur={(e) => this.update("phone", e.target.value)}
              />
              <div className="text-danger">
                <small>{this.state.phoneError}</small>
              </div>
            </Col>
          </Form.Group>
        </Fieldset>

        <Fieldset>
          <Legend>
            <FormattedMessage id="Access.PHARMAMAD" />
          </Legend>
          <Form.Group as={Row} className="mb-3 align-items-center">
            <CustomLabel
              label={this.props.intl.formatMessage({
                id: "Username.Connexion",
              })}
              htmlFor="username"
              displayAsCol
              required
            />
            <Col md={7}>
              <Form.Group as={Row} className="mb-3 align-items-center">
                <Col>
                  <InputTextElement
                    type="text"
                    id="username"
                    autoComplete="off"
                    maxLength={InputLength.NAME}
                    value={this.state.username}
                    onChange={(e) =>
                      this.onChange("username", e.target.value.toLowerCase())
                    }
                    onBlur={(e) => this.update("username", e.target.value)}
                  />
                </Col>
                <Col md={4}>-{this.props.company.url}</Col>
              </Form.Group>
              <div className="text-danger">
                <small>{this.state.usernameError}</small>
              </div>
            </Col>
          </Form.Group>
          {this.isUpdate() && this.props.collaborator.password === null && (
            <Row>
              <Col>
                <Alert variant="warning" className="text-center">
                  <Icon icon="warning" />{" "}
                  <FormattedMessage id="User.Has.No.Access" />
                  <MenuButton
                    className="mt-3"
                    icon="paper-plane"
                    variant="warning"
                    onClick={() =>
                      this.props.onSendWelcomeEmail(
                        { userId: this.props.collaborator._id },
                        () => this.openEmailSent(),
                      )
                    }
                  >
                    <FormattedMessage id="Send.Mail.Notify.Created.Account" />
                  </MenuButton>
                </Alert>
              </Col>
            </Row>
          )}
          {!this.isUpdate() && (
            <Form.Group as={Row} className="mb-3 align-items-center">
              <CustomLabel
                label={this.props.intl.formatMessage({
                  id: "Send.Mail.Notify.Created.Account",
                })}
                htmlFor="notifyByEmail"
                displayAsCol
              />
              <Col md={7}>
                <SwitchToggle
                  type={"checkbox"}
                  id="notifyByEmail"
                  onChange={(e) => {
                    this.onChange("notifyByEmail", e);
                  }}
                  checked={this.state.notifyByEmail}
                />
              </Col>
            </Form.Group>
          )}
        </Fieldset>

        {!this.isUpdate() && (
          <Form.Group as={Row} className="justify-content-center pt-3">
            <Col md={6}>
              <MenuButton
                className="w-100"
                disabled={this.disabled()}
                onClick={() => this.onSubmit()}
              >
                <FormattedMessage id="Add" />
              </MenuButton>
            </Col>
          </Form.Group>
        )}

        {this.state.modal}
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    collaborators: state.collaborators,
    collaboratorTypes: state.collaboratorTypes,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onAddCollaboratorType: (data, successCallback) =>
      dispatch(addCollaboratorType(data, successCallback)),
    onAddCollaborator: (data, successCallback) =>
      dispatch(addCollaborator(data, successCallback)),
    onUpdateCollaborator: (data) => dispatch(updateCollaborator(data)),
    onCheckIfUsernameExists: (username, existsCallback, noExistsCallback) =>
      dispatch(
        checkIfUsernameExists(username, existsCallback, noExistsCallback),
      ),
    onCheckIfEmailExists: (email, existsCallback, noExistsCallback) =>
      dispatch(checkIfEmailExists(email, existsCallback, noExistsCallback)),
    onCheckIfEmailIsValid: (email, isValidCallback, notValidCallback) =>
      dispatch(checkIfEmailIsValid(email, isValidCallback, notValidCallback)),
    onSendWelcomeEmail: (data, successCallback) =>
      dispatch(sendWelcomeEmail(data, successCallback)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(Collaborator));
